import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import './Header.css';

const Header = () => {

  // Change Background Header on Scroll
  useEffect(() => {
    const changeHeaderBackground = () => {
      const header = document.querySelector(".header");
      if (window.scrollY >= 80) {
        header.classList.add("scroll__header");
      } else {
        header.classList.remove("scroll__header");
      }
    };

    window.addEventListener("scroll", changeHeaderBackground);
    return () => window.removeEventListener("scroll", changeHeaderBackground);
  }, []);

  // Toggle Menu
  const [Toggle, showMenu] = useState(false);
  const [activeNav, setActiveNav] = useState("home");

  return (
    <header className="header">
      <nav className="nav container">
        <a href="index.html" className="nav__logo">Ebrahim</a>

        <div className={Toggle ? "nav__menu show-menu" : "nav__menu"}>
          <ul className="nav__list grid">
            <li className="nav__item">
              <Link to="home" spy={true} smooth={true} offset={-50} duration={500}
                onClick={() => setActiveNav("home")}
                className={activeNav === "home" ? "nav__link active__link" : "nav__link"}>
                <i className="uil uil-estate nav__icon"></i> Home
              </Link>
            </li>
            <li className="nav__item">
              <Link to="about" spy={true} smooth={true} offset={-50} duration={500}
                onClick={() => setActiveNav("about")}
                className={activeNav === "about" ? "nav__link active__link" : "nav__link"}>
                <i className="uil uil-user nav__icon"></i> About
              </Link>
            </li>
            <li className="nav__item">
              <Link to="skills" spy={true} smooth={true} offset={-50} duration={500}
                onClick={() => setActiveNav("skills")}
                className={activeNav === "skills" ? "nav__link active__link" : "nav__link"}>
                <i className="uil uil-file-alt nav__icon"></i> Skills
              </Link>
            </li>
            <li className="nav__item">
              <Link to="services" spy={true} smooth={true} offset={-50} duration={500}
                onClick={() => setActiveNav("services")}
                className={activeNav === "services" ? "nav__link active__link" : "nav__link"}>
                <i className="uil uil-briefcase-alt nav__icon"></i> Services
              </Link>
            </li>
            <li className="nav__item">
              <Link to="portfolio" spy={true} smooth={true} offset={-50} duration={500}
                onClick={() => setActiveNav("portfolio")}
                className={activeNav === "portfolio" ? "nav__link active__link" : "nav__link"}>
                <i className="uil uil-scenery nav__icon"></i> Qualification
              </Link>
            </li>
            <li className="nav__item">
              <Link to="contact" spy={true} smooth={true} offset={-50} duration={500}
                onClick={() => setActiveNav("contact")}
                className={activeNav === "contact" ? "nav__link active__link" : "nav__link"}>
                <i className="uil uil-message nav__icon"></i> Contact
              </Link>
            </li>
          </ul>

          <i className="uil uil-times nav__close" onClick={() => showMenu(!Toggle)}></i>
        </div>
        <div className="nav__toggle" onClick={() => showMenu(!Toggle)}>
          <i className="uil uil-apps"></i>
        </div>
      </nav>
    </header>
  );
};

export default Header;
